import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Form, Formik, FieldArray } from "formik";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import { useDispatch, useSelector } from "react-redux";

import * as yup from "yup";
import { Delete } from "@mui/icons-material";
import FormControl from "Components/MUI_components/FormControl/fomikFormControl";
import Stepper from "Components/MUI_components/stepper";
import ItemMasterService from "Service/Item-master/itemMaster.service";
import AsyncAutoComplete from "../../MUI_components/AutoComplete/asynchronousAutoComplete";
import customerService from "Service/Customer/customer.service";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import Loading from "Components/MUI_components/loading";
import { Box } from "@mui/system";
import { NumFormat } from "Components/MUI_components/currencyFormat";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import SalseOderService from "Service/Stock/salesOrder.service"

const SalesOrder = ({ setOpen, code, setSubmitted }) => {
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);
  const stockLocations = useSelector((state) => state.location);
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);
  const addingProduct = React.createRef();
  const [disabledForSingle, setDisabledForSingle] = useState(false);


  const initCurrentStockValue = {
    quantity: "",
    stock: ""
  };

  const initValues = {
    customer: null,
    remarks: "",
    stockHistories: [],
  };
  
  const Validation = yup.object({
    customer: yup.object().required("Customer is required").nullable(),
  });
  const [initValue, setInitValue] = useState(initValues);
  const [currentStock, setCurrentStock] = useState(initCurrentStockValue);

  const handleStockDataChange = (e) => {
    const { name } = e.target;
    const { value } = e.target;

    setCurrentStock({
      ...currentStock,
      [name]: value,

    });
  };


  useEffect(() => {
    const getSalseOrder = async () => {
      if (code) {
        try {
          let response = await SalseOderService.get(code);
          // converting NULL value into Empty string
          response = JSON.parse(
            JSON.stringify(response).replace(/:null/gi, ':""')
          );
          setInitValue(response);
        } catch (e) {
          dispatch(openSnackbar(true, "error", e));
        }
      } else {
        setInitValue(initValues)
      }
      setIsLoaded(true);
    };
    getSalseOrder();
  }, [code, dispatch]);


  const [activeStep, setActiveStep] = React.useState(0);

  const getSteps = ["Sales Order", "Sales Order Daae"];
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSubmit = async (values) => {
    setDisabledForSingle(true);
    try {

      if (code)
        await SalseOderService.edit({ ...values }, code);
      else await SalseOderService.create({
        ...values,
      });
      setSubmitted((prev) => !prev);
      setOpen(false);

      dispatch(
        openSnackbar(
          true,
          "success",
          `Salse order ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }

    setTimeout(() => {
      setDisabledForSingle(false);
    }, 10000); // 10 seconds
  };
  return (
    <>
      {isLoaded ? (
        <Formik
          initialValues={initValue}
          validationSchema={Validation}
          onSubmit={async (values) => {
            if (activeStep === getSteps.length - 1) {
              await handleSubmit(values);
              console.log(values);
            } else handleNext();
          }}
        >
          {(props) => (
            <Form>
              <Stepper
                getSteps={getSteps}
                StepContent={getStepContent}
                activeStep={activeStep}
                values={props.values}
                setFieldValue={props.setFieldValue}
              />

              {/* 
            Back Button */}
              <div className="row space-between mb">
                <Button
                  disabled={activeStep === 0 || props.isValid === false}
                  onClick={handleBack}
                >
                  Back
                </Button>

                <div style={{ display: "flex" }}>
                  <Button
                    disabled={
                      disabledForSingle ||
                      props.isSubmitting ||
                        (!props.values.stockHistories.length &&
                          activeStep === getSteps.length - 1)
                        ? true
                        : false 
                        
                    }
                    startIcon={
                      props.isSubmitting && (
                        <CircularProgress color="inherit" size={20} />
                      )
                    }
                    variant="contained"
                    type="submit"
                    color="secondary"
                  >
                    {activeStep === getSteps.length - 1 ? "Complete" : "Next"}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <Loading />
      )}
    </>
  );
  function getStepContent(step, values, setFieldValue) {

    const handleLineTotal = (qty, price, discountPer, discountAmount) => {
      let totalAmount = qty * price;
      discountAmount = discountAmount * qty;
      let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
      return lineTotalAmount;
    };
    const subTotalAmount = values.stockHistories
          .map(({ quantity, discountPercentage, discountAmount, retailPrice, warrantyPeriods }) =>
            handleLineTotal(
              quantity,
              retailPrice,
              discountPercentage,
              discountAmount,
              warrantyPeriods
            )
          )
          .reduce((sum, i) => sum + i, 0);

    const totalAmount = values.stockHistories
      .map((data) =>
        data.retailPrice * data.quantity)
      .reduce((sum, i) => sum + i, 0);
    switch (step) {
      case 0:
        return (
          <>
            <div className="row">
            <div className="col-4">
                <FormControl
                  control="asynchronousAutoComplete"
                  label="Customer"
                  name="customer"
                  Service={customerService}
                  getOptionLabel={(option) =>
                    option.firstName + "-" +
                    option.phone1  + "-" +
                    option.code
                  }
                />
              </div>
              <div className="col-8">
                <FormControl name="remarks" label="Remarks" control="input" />
              </div>
            </div>
          
          </>
        );
      case 1:
        return (
          <FieldArray name="stockHistories">
            {(props) => {
              const { push, remove, form } = props;
              const { setFieldValue, values } = props.form;
              const { stockHistories } = form.values;
              return (
                <>
                  <div className="row">

                    <div className="col-8">
                      <AsyncAutoComplete
                        fullWidth
                        inputProps={{
                          placeholder: `Select Product`,
                          size: "small",
                          ref: addingProduct,
                        }}
                        variant="filled"
                        Service={ItemMasterService.posSearch}
                        value={currentStock.stock}
                        getOptionLabel={(option) =>
                          option.itemMaster.name +
                          " | " +
                          option.stockCode +
                          " | " +
                          option.itemMaster.barcode +
                          " | " +
                          option.itemMaster.description
                        }
                       
                        onChange={(e, newValue) => {
                          newValue === null
                            ? setCurrentStock({
                              ...currentStock,
                              stock: "",
                              quantity: ""
                            })
                            : setCurrentStock({
                              ...currentStock,
                              stock: newValue,
                            })
                        }}
                      />
                    </div>
                    <div className="col-4">
                      <NumFormat
                        name="quantity"
                        label="Quantity*"
                        control="currency"
                        value={currentStock.quantity}
                        onChange={handleStockDataChange}
                        variant="outlined"
                      />
                    </div>
                  </div>

                  <div className="row flex-end">
                    <Button
                      variant="contained"
                      disabled={(parseFloat(currentStock.quantity) > parseFloat(currentStock.stock?.remainingQuantity))
                        || !currentStock.stock || !currentStock.quantity}
                      onClick={() => {
                        push({
                          stockCode: currentStock.stock.code,
                          itemMaster: currentStock.stock.itemMaster,
                          costPrice: currentStock.stock.costPrice,
                          retailPrice: currentStock.stock.retailPrice,
                          wholesalePrice: currentStock.stock.wholesalePrice,
                          quantity: currentStock.quantity,
                          discountAmount: 0,
                          discountPercentage: 0,
                          discountTotal: 0,
                        });

                        setCurrentStock(initCurrentStockValue);
                      }}
                    >
                      Add
                    </Button>
                  </div>
                  <div className="row mt mb">
                    <TableContainer>
                      <Table size="small" aria-label="spanning table">
                        <TableHead style={{ backgroundColor: "#cacaca50" }}>
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              Details
                            </TableCell>
                            <TableCell align="right">Price</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell width="5"></TableCell>
                            <TableCell width="5">#</TableCell>
                            <TableCell>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.QUANTITY}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.RETAIL_PRICE}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.DISCOUNT_PERCENTAGE}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.DISCOUNT_AMOUNT}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.TOTAL}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {values.stockHistories.map((row, i) => (
                            <TableRow key={i}>

                              <TableCell width="5">
                                {!code ? (
                                  <Delete
                                    color="secondary"
                                    style={{
                                      fontSize: 18,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (
                                        window.confirm(
                                          "Are you sure want to delete this?"
                                        )
                                      )
                                        remove(i);
                                    }}
                                  />
                                )
                                  : (
                                    <></>
                                  )}
                              </TableCell>

                              <TableCell width="5">{i + 1}</TableCell>
                              <TableCell>{row.itemMaster.name}</TableCell>
                              <TableCell align="right">
                                <FormControl
                                  control="customInput"
                                  name={`stockHistories[${i}].quantity`}
                                />
                              </TableCell>

                               <TableCell align="right">
                                <FormControl
                                  control="customInput"
                                  name={`stockHistories[${i}].retailPrice`}
                                />
                              </TableCell>
                              <TableCell align="right">
                                <FormControl
                                  control="customInput"
                                  name={`stockHistories[${i}].discountPercentage`}
                                />
                              </TableCell>
                              <TableCell align="right">
                                <FormControl
                                  control="customInput"
                                  name={`stockHistories[${i}].discountAmount`}
                                />
                              </TableCell>
                           
                            

                              <TableCell align="right">
                                {currency(handleLineTotal(
                                  row.quantity,
                                  row.retailPrice,
                                  row.discountPercentage,
                                  row.discountAmount
                                ))}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                        <TableHead>
                          {values.stockHistories.length === 0 ? (
                            <TableRow>
                              <TableCell align="center" colSpan={6}>
                                No Data
                              </TableCell>
                            </TableRow>
                          ) : (
                            <>
                              <TableRow>
                                <TableCell colSpan={6} />
                                <TableCell>
                                  <strong>Total</strong>
                                </TableCell>
                                <TableCell align="right">
                                  <strong>{currency(subTotalAmount)}</strong>
                                </TableCell>
                              </TableRow>
                            </>
                          )}
                        </TableHead>
                      </Table>
                    </TableContainer>
                  </div>
                </>
              );
            }}
          </FieldArray>
        );
      default:
        return null;
    }
  }
};

export default SalesOrder;
